import { Biohazard, Linkedin, Mail, Plus } from 'lucide-react';
import { LabeledBtn } from './LabeledBtn';
import React from 'react';
import LinkedInCsvImporter from './LinkedinCsvImporter';

type ImportExportOptionsProps = {
  onAddOne: () => void;
  onGenerateRandom: () => void;
  onGmailImport?: () => void;
  onLinkedInCsvImport?: () => void;
};

export const ImportExportOptions = (props: ImportExportOptionsProps) => {

  const handleGmailImport = () => {
    // Implement add functionality
    console.log("Adding data...");
  };

  const handleLinkedInCsvImport = () => {
    document
      .getElementById('linkedin_csv_importer_dialog')
      // @ts-ignore
      ?.showModal();
  };

  const iconButtons = [
    { icon: <Plus />, label: 'Manually Add', onClick: props.onAddOne },
    { icon: <Biohazard />, label: 'Generate Fake Data', onClick: props.onGenerateRandom },
    { icon: <Linkedin />, label: 'LinkedIn', onClick: handleLinkedInCsvImport },
    { icon: <Mail />, label: 'Gmail', onClick: handleGmailImport },
  ];

  return (
    <>
      <div className="text-center text-gray-500">
        <p>No nodes found. You can export or import nodes using the options below.</p>
        <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {iconButtons.slice(0, 4).map((button) => (
            <LabeledBtn key={button.label} icon={button.icon} label={button.label} onClick={button.onClick} />
          ))}
        </div>
      </div>
      <LinkedInCsvImporter />
    </>
  );
};